<script setup lang="ts">
import type { EventDetailsBeneficiary } from "mws-ts-v2-sdk";

const props = defineProps<{
  beneficiary: EventDetailsBeneficiary;
}>();

const websiteUrlAsAbsolutePath = computed(() => {
  const link = props.beneficiary.websiteUrl;

  if (!link) return null;

  return getWebsiteUrlAsAbsolutePath(link);
});
</script>

<template>
  <ProductDescriptionDrawerBase :title="$t('product.description.money')">
    <template #content>
      <div class="flex flex-col">
        <img
          v-if="beneficiary.logoUrl"
          class="object-contain max-h-24 flex self-center mt-4 mb-8"
          :src="beneficiary.logoUrl"
          :alt="`${beneficiary.name} logo`"
        />
        <span
          v-if="beneficiary.name"
          class="font-bold uppercase mb-1"
        >
          {{ beneficiary.name }}
        </span>
        <!-- eslint-disable vue/no-v-html -->
        <span
          v-if="beneficiary.description"
          class="text-platform-text-2"
          v-html="beneficiary.description"
        />
        <!-- eslint-enable vue/no-v-html -->
        <I18nT
          v-if="websiteUrlAsAbsolutePath"
          scope="global"
          keypath="product.description.website"
          tag="p"
          class="text-platform-text-2 mt-1"
        >
          <template #link>
            <a
              :href="websiteUrlAsAbsolutePath"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("product.description.websiteLink") }}
            </a>
          </template>
        </I18nT>
      </div>
    </template>
  </ProductDescriptionDrawerBase>
</template>
